var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { agendaOfType, } from "../types/agenda";
var AGENDA_PREFIX = "ui-br-legaldeposits.agenda";
export var agendaDeviation = function (agenda, globalType) {
    if (!agenda || !globalType || agendaOfType(globalType) === agenda) {
        return null;
    }
    return { agenda: agenda, globalType: globalType };
};
// A unit stays listed in both agendas of the library; only the department that handles it acts on it.
export var handledElsewhere = function (agenda, listedIn) { return !!agenda && agenda !== listedIn; };
export var agendaReason = function (agenda) {
    if (agenda.decidedByLinkedIssue)
        return "LINKED_ISSUE";
    if (agenda.overridden)
        return "LIBRARY";
    return "DEFAULT";
};
export var agendaReasonLabelId = function (reason) {
    return "".concat(AGENDA_PREFIX, ".reason.").concat(reason);
};
var KNOWN_VALUES = new Set([
    "MONOGRAPHS",
    "PERIODICALS",
    "MONOGRAPH",
    "PERIODICAL",
]);
// History values are stored as text: an agenda for library decisions, a title type for the NK fix.
export var agendaValueLabelId = function (value) {
    return value && KNOWN_VALUES.has(value) ? "".concat(AGENDA_PREFIX, ".value.").concat(value) : null;
};
export var agendaChangeLabelId = function (change) {
    if (change.changeKind === "TITLE_AGENDA" && change.issueId) {
        return "".concat(AGENDA_PREFIX, ".history.kind.ISSUE_AGENDA");
    }
    return "".concat(AGENDA_PREFIX, ".history.kind.").concat(change.changeKind);
};
export var sortChangesNewestFirst = function (changes) {
    return __spreadArray([], changes, true).sort(function (a, b) { return b.changedAt.localeCompare(a.changedAt); });
};
// The decision behind the title's current agenda: the newest title-level change (an NK fix of the
// global type does not decide for a library that overrode it).
export var latestTitleDecision = function (changes) {
    var _a;
    return (_a = sortChangesNewestFirst(changes).find(function (change) { return change.changeKind === "TITLE_AGENDA" && !change.issueId; })) !== null && _a !== void 0 ? _a : null;
};
export var skippedHandledElsewhereOf = function (result) {
    var _a;
    return result != null && typeof result === "object" && !Array.isArray(result)
        ? ((_a = result.skippedHandledElsewhere) !== null && _a !== void 0 ? _a : 0)
        : 0;
};
